export default "__VITE_ASSET__DqZiR_7r__"